import styled from 'styled-components';
import { paddings, mediaQuery } from '~/styled/variables';
import { zBanners } from '~/styled/z-index';

export const CookieBannerDiv = styled.div`
  z-index: ${zBanners};
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--surface);
  border-top: 1px solid var(--ui-gray300);
  padding: ${paddings.mediumPadding} ${paddings.largePadding};
`;

export const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: ${paddings.mediumPadding};

  ${mediaQuery.up.l`
    flex-direction: row;
    align-items: center;
    gap: ${paddings.largePadding};
  `}
`;

export const MessageSpan = styled.span`
  color: var(--on-surface);
`;

export const PolicyLink = styled.a`
  &:link,
  &:visited {
    color: var(--brand-100);
  }

  &:hover,
  &:active {
    color: var(--brand-110);
  }
`;

export const ButtonsDiv = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${paddings.smallPadding};

  ${mediaQuery.up.l`
    flex-direction: row;
    gap: ${paddings.smallPadding};
  `}
`;
